import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "../lib/api";
import { t } from "../lib/i18n";
import { qk } from "./keys";
import type { Me } from "./types";

export function useMe() {
  return useQuery({
    queryKey: qk.me,
    queryFn: ({ signal }) => api<Me>("/api/me", { signal }),
    staleTime: 60_000,
  });
}

export function useSetGitIdentities() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (identities: string[]) =>
      api<{ identities: string[] }>("/api/me/git-identities", { method: "PUT", body: { identities } }),
    meta: { errorTitle: t("Git identities not saved") },
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: qk.me });
      void client.invalidateQueries({ queryKey: qk.reports });
    },
  });
}
